import { render, staticRenderFns } from "./DarkToggle.vue?vue&type=template&id=3074d094&scoped=true&"
import script from "./DarkToggle.vue?vue&type=script&lang=js&"
export * from "./DarkToggle.vue?vue&type=script&lang=js&"
import style0 from "./DarkToggle.vue?vue&type=style&index=0&id=3074d094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3074d094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
